import { render, staticRenderFns } from "./ProductDropdown.vue?vue&type=template&id=ed0db702&scoped=true"
import script from "./ProductDropdown.vue?vue&type=script&lang=js"
export * from "./ProductDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductDropdown.vue?vue&type=style&index=0&id=ed0db702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0db702",
  null
  
)

export default component.exports